export default __webpack_public_path__ + "static/media/gsb.428d0bd7.svg";